import smoothscroll from "smoothscroll-polyfill";

// スムーススクロールのポリフィル（古いブラウザ対応）
smoothscroll.polyfill();

// DOMContentLoaded時の処理
document.addEventListener("DOMContentLoaded", function () {
  // Quick Findタブ切り替え
  const chips = document.querySelectorAll(".chip");
  const panels = document.querySelectorAll(".panel");

  chips.forEach((chip) => {
    chip.addEventListener("click", function () {
      const tabName = this.getAttribute("data-quickfind-tab");

      // すべてのチップからアクティブクラスを削除
      chips.forEach((c) => {
        c.classList.remove("is-active");
        c.setAttribute("aria-selected", "false");
      });

      // クリックされたチップにアクティブクラスを追加
      this.classList.add("is-active");
      this.setAttribute("aria-selected", "true");

      // すべてのパネルを非表示
      panels.forEach((panel) => {
        panel.classList.remove("is-active");
        panel.setAttribute("hidden", true);
      });

      // 対応するパネルを表示
      const targetPanel = document.querySelector(`[data-panel="${tabName}"]`);
      if (targetPanel) {
        targetPanel.classList.add("is-active");
        targetPanel.removeAttribute("hidden");
      }
    });
  });

  // FAQアコーディオン
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const accordionItem = this.parentElement;
      const isActive = accordionItem.classList.contains("active");

      // すべてのアコーディオンを閉じる
      document.querySelectorAll(".accordion-item").forEach((item) => {
        item.classList.remove("active");
      });

      // クリックされたものがアクティブでなければ開く
      if (!isActive) {
        accordionItem.classList.add("active");
      }
    });
  });

  // ビデオモーダル
  const modalTriggers = document.querySelectorAll("[data-modal-trigger]");
  const modal = document.getElementById("hero-video-modal");
  const modalClose = modal?.querySelector(".modal-close");
  const modalOverlay = modal?.querySelector(".modal-overlay");
  const modalVideo = modal?.querySelector(".modal-video");

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      if (modal) {
        modal.removeAttribute("hidden");
        modalVideo?.play();
      }
    });
  });

  // モーダルを閉じる
  [modalClose, modalOverlay].forEach((element) => {
    element?.addEventListener("click", function () {
      if (modal) {
        modal.setAttribute("hidden", true);
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.currentTime = 0;
        }
      }
    });
  });

  // Escキーでモーダルを閉じる
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal && !modal.hasAttribute("hidden")) {
      modal.setAttribute("hidden", true);
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      }
    }
  });

  // スムーススクロール（アンカーリンク）
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      if (href === "#" || href === "") return;

      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // データトラッキング（CTAクリック）
  document.querySelectorAll("[data-cta]").forEach((cta) => {
    cta.addEventListener("click", function () {
      const ctaName = this.getAttribute("data-cta");
      console.log("CTA clicked:", ctaName);
      // ここにGoogle Analytics等のトラッキングコードを追加可能
    });
  });
});
